import { render, staticRenderFns } from "./Program.vue?vue&type=template&id=1381ebba&scoped=true"
import script from "./Program.vue?vue&type=script&lang=js"
export * from "./Program.vue?vue&type=script&lang=js"
import style0 from "./Program.vue?vue&type=style&index=0&id=1381ebba&prod&scoped=true&lang=css"
import style1 from "./Program.vue?vue&type=style&index=1&id=1381ebba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1381ebba",
  null
  
)

export default component.exports